import {
  CREATE_CATEGORY,
  CREATE_CATEGORY_FAILED,
  CREATE_CATEGORY_SUCCESS,
  DELETE_CATEGORY,
  DELETE_CATEGORY_FAILED,
  DELETE_CATEGORY_SUCCESS,
  EDIT_CATEGORY,
  EDIT_CATEGORY_FAILED,
  EDIT_CATEGORY_SUCCESS,
  GET_CATEGORIES,
  GET_CATEGORIES_FAILED,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORY,
  GET_CATEGORY_FAILED,
  GET_CATEGORY_SUCCESS,
  HIDE_CATEGORY_ERROR_MODAL,
  HIDE_DELETE_CATEGORY_MODAL,
  HIDE_EDIT_CATEGORY_MODAL,
  OPEN_CATEGORY_ERROR_MODAL,
  OPEN_DELETE_CATEGORY_MODAL,
  OPEN_EDIT_CATEGORY_MODAL,
  RESET_CATEGORY,
  UPDATE_CATEGORY_ORDER_SUCCESS,
  UPDATE_MULTIPLE_CATEGORIES_ORDER,
} from "./actionTypes"

const INIT_STATE = {
  categories: [],
  loading: false,
  error: "",
  isEditCategoryModalOpen: false,
  isDeleteCategoryModalOpen: false,
  isCategoryErrorModalOpen: false,
  category: null,
}

const Categories = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CATEGORIES:
    case CREATE_CATEGORY:
    case EDIT_CATEGORY:
    case DELETE_CATEGORY:
    case GET_CATEGORY:
      return {
        ...state,
        loading: true,
      }
    case GET_CATEGORIES_FAILED:
    case CREATE_CATEGORY_FAILED:
    case EDIT_CATEGORY_FAILED:
    case DELETE_CATEGORY_FAILED:
    case GET_CATEGORY_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case CREATE_CATEGORY_SUCCESS:
    case DELETE_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
        loading: false,
      }
    case OPEN_EDIT_CATEGORY_MODAL:
      return {
        ...state,
        isEditCategoryModalOpen: true,
      }
    case HIDE_EDIT_CATEGORY_MODAL:
      return {
        ...state,
        isEditCategoryModalOpen: false,
      }
    case OPEN_DELETE_CATEGORY_MODAL:
      return {
        ...state,
        isDeleteCategoryModalOpen: true,
      }
    case HIDE_DELETE_CATEGORY_MODAL:
      return {
        ...state,
        isDeleteCategoryModalOpen: false,
      }
    case OPEN_CATEGORY_ERROR_MODAL:
      return {
        ...state,
        isCategoryErrorModalOpen: true,
      }
    case HIDE_CATEGORY_ERROR_MODAL:
      return {
        ...state,
        isCategoryErrorModalOpen: false,
      }
    case UPDATE_CATEGORY_ORDER_SUCCESS:
      return {
        ...state,
        categories: state.categories.map(category =>
          category.id === action.payload.id
            ? { ...category, order: action.payload.order }
            : category
        ),
      }
    case EDIT_CATEGORY_SUCCESS:
      return {
        ...state,
        categories: state.categories.map(category =>
          category.id === action.payload.categoryId
            ? { ...category, name: action.payload.data.name }
            : category
        ),
        loading: false,
      }
    case GET_CATEGORY_SUCCESS:
      return {
        ...state,
        category: action.payload,
        loading: false,
      }
    case RESET_CATEGORY:
      return {
        ...state,
        category: null,
      }
    case UPDATE_MULTIPLE_CATEGORIES_ORDER:
      return {
        ...state,
        categories: state.categories.map(category => {
          const updatedCategory = action.payload?.find(
            x => x?.id === category?.id
          )
          if (!!updatedCategory) {
            return { ...category, order: updatedCategory?.order }
          } else {
            return category
          }
        }),
      }
    default:
      return state
  }
}

export default Categories
